import { render, staticRenderFns } from "./imgList.vue?vue&type=template&id=649f9f88&scoped=true&"
import script from "./imgList.vue?vue&type=script&lang=js&"
export * from "./imgList.vue?vue&type=script&lang=js&"
import style0 from "./imgList.vue?vue&type=style&index=0&id=649f9f88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649f9f88",
  null
  
)

export default component.exports